var doc = document.documentElement;
var w = window;
var prevScroll = w.scrollY || doc.scrollTop;
// var curScroll;
var direction = 0;
var prevDirection = 0;

var header = document.getElementById('masthead');

var checkScroll = function(curScroll) {

  /*
   * Find the direction of scroll
   * 0 - initial, 1 - up, 2 - down
  */
  curScroll = w.scrollY || doc.scrollTop;
  if (curScroll > prevScroll) {
    //scrolled up
    direction = 2;
  }
  else if (curScroll < prevScroll) {
    //scrolled down
    direction = 1;
  }

  if (direction !== prevDirection) {
    toggleHeader(direction, curScroll);
  }

  if (curScroll > header.offsetHeight) {
    header.classList.add('site-header--scrolled');
  } else {
    header.classList.remove('site-header--scrolled');
  }

  prevScroll = curScroll;
};

var toggleHeader = function(direction, curScroll) {
  let headerHeight = header.offsetHeight;
  if (direction === 2 && curScroll > headerHeight) {
    header.style.top = -headerHeight + 'px';
    prevDirection = direction;
  } else if (direction === 1) {
    header.style.top = 0;
    prevDirection = direction;
  }
};

if (header) {
  let lastKnownScrollPosition = 0;
  let ticking = false;

  window.addEventListener('scroll', (e) => {
    lastKnownScrollPosition = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        checkScroll(lastKnownScrollPosition);
        ticking = false;
      });

      ticking = true;
    }
  });
}
